import React from "react";
import {userHasAnyRole} from "../../../utils/SecurityUtils";
import * as PropTypes from "prop-types";
import {AnlagenHeader} from "./AnlagenHeader";
import {AnlagenEinleiter} from "./AnlagenEinleiter";
import {LageVerortung} from "../common/LageVerortung";
import {BEAUFTRAGTER, BETREIBER, FACHADMIN, SYSTEMADMIN, ZUST_SBD} from "../../../consts/funktionaleRollen";
import {ABWASSERBEHANDLUNG} from "../../../consts/anlagentyp";
import AnlagenFooter from "./AnlagenFooter";
import {useAnlagenstatus} from "../../../services/AnlagenService";
import AnlagensystemSelector from "./AnlagensystemSelector";
import {useHttp} from "../../../services/HttpService";
import {getSuevoaAnlageNrEndpoint} from "../../../services/WertelistenService";

export default function Abwasserbehandlung(props) {
    const [anlagenstatusOptionen] = useAnlagenstatus(props.data?.anlagenart?.id, props.data?.anlagentyp?.id, props.betriebstyp?.id);
    const abwasserbeseitigungspflichtige = props.data?.abwasserbeseitigungspflichtige ? props.data.abwasserbeseitigungspflichtige : [];
    const [suevoaAnlageNr] = useHttp(getSuevoaAnlageNrEndpoint);

    function isDisabled() {
        if (!props.anlageId) return false;
        if (props.modus === "l") {
            return true;
        }
        if (props.modus === "s") {
            return !userHasAnyRole([FACHADMIN, SYSTEMADMIN, ZUST_SBD]);
        }
        return true;
    }

    function isEbtImportDisabled() {
        if (!props.anlageId) return false;
        if (props.modus === "l") {
            return true;
        }
        if (props.modus === "s") {
            return !userHasAnyRole([FACHADMIN, SYSTEMADMIN, ZUST_SBD, BETREIBER, BEAUFTRAGTER]);
        }
        return true;
    }

    function isLageVerortungDisabled() {
        if (!props.anlageId) return false;
        if (props.modus === "s") {
            return !userHasAnyRole([FACHADMIN, SYSTEMADMIN]);
        }
        return true;
    }

    return (
        <div className="gridl tabsheet-content-margin">
            <AnlagenHeader
                formFactory={props.formFactory}
                withAnlagenart
                angeschlosseneAnlage={props.data?.angeschlosseneAnlage}
                anlagenstatus={props.data?.anlagenstatus}
                disabled={!props.anlageId && isDisabled()}
                statusDisabled={!props.anlageId || isDisabled()}
                anlagenstatusOptionen={anlagenstatusOptionen.data}
            />
            <AnlagenEinleiter
                formFactory={props.formFactory}
                betriebsId={props.betriebsId}
                anlageId={props.anlageId}
                anlagentyp={ABWASSERBEHANDLUNG}
                disabled={isDisabled()}
                errors={props.errors}
                onChange={props.onChange}
                indirekteinleiter={props.data.indirekteinleiter}
                isButtonVisible={userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN])}
                abwasserbeseitigungspflichtige={abwasserbeseitigungspflichtige}
            />
            <LageVerortung
                formFactory={props.formFactory}
                disabled={isLageVerortungDisabled()}
                data={props.data}
                onClick={(lage) => props.onChange("lage", lage)}
                isButtonVisible={userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN])}
                modus={props.modus}
            />
            <AnlagensystemSelector formFactory={props.formFactory} disabled={isDisabled()}/>

            <div className="gridl" style={{gridTemplateColumns: "repeat(3, 1fr)", alignItems: "center"}}>

                <div style={{gridColumn: "1 / 3"}}>
                    {props.formFactory.renderAutocomplete(
                        "suevoaAnlageNr",
                        "suevoaAnlageNr",
                        "SÜVOA Anlage Nr.",
                        suevoaAnlageNr.data,
                        "value",
                        "key",
                        suevoaAnlageNr.loading,
                        false,
                        isDisabled(),
                        {
                            fullWidth: true,
                            style: {width: "100%", minWidth: "60ch"},
                        }
                    )}
                </div>

                {props.formFactory.renderCheckbox(
                    "ebtImport",
                    "ebtImport",
                    "eBT-Import",
                    isEbtImportDisabled(),
                    { style: { alignSelf: "center" }}
                )}
            </div>
            <div className="gridl" style={{gridTemplateColumns: "repeat(5, 1fr)", alignItems: "center"}}>

                {props.formFactory.renderCheckbox(
                    "chargenbetrieb",
                    "chargenbetrieb",
                    "Chargenbetrieb",
                    isDisabled(),
                    {style: {alignSelf: "center"}}
                )}
                {props.formFactory.renderCheckbox(
                    "kampagne",
                    "kampagne",
                    "Kampagnenbetrieb",
                    isDisabled(),
                    {style: {alignSelf: "center"}}
                )}
                {props.formFactory.renderCheckbox(
                    "selbstueberwachungspflicht",
                    "selbstueberwachungspflicht",
                    "Selbstüberwachungspflicht",
                    isDisabled(),
                    {style: {alignSelf: "center"}}
                )}

                {/* Inputs bleiben in Spalte 4 und 5 */}
                {props.formFactory.renderInput("dwaNr", "dwaNr", "DWA Nr.", "text", isDisabled(), {
                    style: { gridColumn: "4" }
                })}
                {props.formFactory.renderInput("staLaNr", "staLaNr", "StaLa Nr.", "text", isDisabled(), {
                    style: { gridColumn: "5" }
                })}
            </div>
            <AnlagenFooter
                formFactory={props.formFactory}
                withAnlagenart={true}
                isDisabled={isDisabled()}/>
        </div>
    );
}

Abwasserbehandlung.propTypes = {
    anlageId: PropTypes.number,
    modus: PropTypes.oneOf(["l", "s"]).isRequired,
};
